export default __webpack_public_path__ + "static/media/element_79.7b1f1a7f.avif";